<template>
  <v-layout
    v-show="value"
    row
    justify-center
    @click="$emit('input', !value)"
  >
    <v-dialog
      v-model="value"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
         {{ strings.areYouSure }}
        </v-card-title>
        <v-card-text>{{ strings.wouldYouLikeToContinue }} {{ action }}?</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            flat
            @click="onNo"
          >
            {{ strings.no }}
          </v-btn>
          <v-btn
            color="secondary"
            flat
            @click="onYes"
          >
            {{ strings.yes }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex"
export default {
  props: ["value", "action"],
  data() {
    return {
      dialog: true
    };
  },
  computed: {
    ...mapGetters("page", ["strings"])
  },
  methods: {
    onNo() {
      this.$emit("input", false);
      this.$emit("answer", false);
    },
    onYes() {
      this.$emit("input", false);
      this.$emit("answer", true);
    }
  }
};
</script>

<style scoped></style>
